import { call, put } from 'redux-saga/effects';
import { OffersAsyncActions } from 'store/actions/offers';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';

function* updateViewedOffers(action) {
  const {
    UpdateViewedOffers: {
      Actions: { SUCCESS, FAILURE },
    },
  } = OffersAsyncActions;
  const {
    payload: { viewedOffers },
  } = action;

  try {
    yield call(apiCall, '/offers/viewed', 'put', viewedOffers);
    yield put(SUCCESS());
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default updateViewedOffers;
